module.exports = __webpack_public_path__ + "static/media/brand-inverse.6c695ccb.png";